/**
 * Pause execution of the program for a specified duration.
 *
 * @param milliseconds the duration for which to pause execution
 */
export const delay = async (milliseconds: number) => new Promise<void>((resolve) => setTimeout(resolve, milliseconds))
